export default function ContainerSimple({className, children, onClose}) {
  return (
    <div className={`w-full max-h-full min-h-0 p-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark overflow-y-auto ${className}`}>
      <div className="w-full min-h-0 flex flex-col gap-6">
        {children}
      </div>
    </div>
  )
}